import Seo from "@/components/Seo";
import React from "react";
import {
  WhyHero, Heading, Reveal, QuoteStrip, IconCardGrid, WhyFinalCTA,
  MilestoneTrackerMock,
} from "@/components/why/WhyParts";
import { VENDOR_CHOOSE_QUOTES, VENDOR_CHOOSE_CARDS } from "@/data/content";

export default function WhyVendorsChoose() {
  return (
    <main>
      <Seo path="/why-workpay/why-vendors-choose-workpay" />
      <WhyHero
        eyebrow="Why Vendors Choose Workpay"
        title={<>Built for vendors who are <span className="text-gradient">done chasing payments.</span></>}
        subtitle="Workpay helps vendors collect project payments, track milestones, organize proof, and move approved milestones into a daily payout flow."
        visual={<MilestoneTrackerMock />}
      />

      <section className="py-16 sm:py-24 bg-[#f7faf8]">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal>
            <Heading
              overline="The reality"
              title={<>You did the work. <span className="text-gradient">Payment should not become a fight.</span></>}
            />
          </Reveal>
          <QuoteStrip quotes={VENDOR_CHOOSE_QUOTES} />
        </div>
      </section>

      <section className="py-16 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal><Heading overline="A better default" title="Workpay gives vendors a better default." /></Reveal>
          <IconCardGrid items={VENDOR_CHOOSE_CARDS} />
        </div>
      </section>

      <section className="py-16 sm:py-24 bg-[#f7faf8]">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 items-center">
          <Reveal>
            <div>
              <Heading
                overline="Look professional"
                title="Professional payment experience, not awkward follow-ups."
                center={false}
              />
              <p className="mt-4 text-base text-slate-500 leading-relaxed">
                Workpay helps vendors look more professional from the first message. Instead of sending bank
                details or basic payment links, vendors send a project page with payment, scope, milestones,
                and approval flow.
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.1}><MilestoneTrackerMock /></Reveal>
        </div>
      </section>

      <section className="py-16 sm:py-24">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <Reveal>
            <Heading
              overline="Fair for both sides"
              title="Customers stay protected too."
              subtitle="Customers can see what they are paying for, track progress, approve milestones, and raise issues clearly."
            />
          </Reveal>
        </div>
      </section>

      <WhyFinalCTA
        title={<>Make Workpay your default <span className="text-[#21c55e]">payment link.</span></>}
        subtitle="Start every project with clarity instead of chasing money after the work is done."
      />
    </main>
  );
}
